export default {"src":"/login-app/[GIT_HASH]/_next/static/media/star_outline.83735e6f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};